<template>
    
    <div>    
       <!--  <p>Id ES {{$route.params.id}}</p> -->
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a>
                    <router-link :to="{name:'r-/'}">Inicio</router-link>
                </a></li>
                <li class="breadcrumb-item active" aria-current="page">Caja</li>
                <li class="breadcrumb-item active li-actualizar-datos" aria-current="page" title="Actualizar datos de caja" v-if="general.otros.app_modo=='online'" @click=actualizar_caja>
                    <i class="fa fa-refresh" aria-hidden="true"></i>
                </li>
            </ol>
        </nav>
        <div>
            <div class="row">
                <div class="col-12 mt-4">
                    <div class="card">
                        <div class="card-body">
                            <!-- <div style="width: 100%; display:flex; justify-content:center;"> -->

                                <div class="form-row">
                                    <div class="form-group col-md-3">
                                        <label for="inputEmail4" style="color:white;">Fecha de caja:</label>                                    
                                        <input type="date" class="form-control input-3d" v-model=datos.registro.fecha_caja @input=cambiar_fecha :disabled=datos.data_table.cargando>
                                        <!----<p style="color:white; text-align:center;">Actualización automatica en {{ this.datos.data_table.proxima_actualizacion }} seg</p>-->
                                    </div>
                                    <div class="form-group col-md-4">
                                        <div v-if="general.verificacion_rol.caja.input_saldo_inicial" style="display:flex; flex-wrap:wrap; align-items:start;">
                                            <div style="margin-right:2em;">
                                                <label for="inputEmail4" style="color:white;">
                                                    Saldo inicial en caja: <span>{{ formato_moneda(datos.registro.saldo_inicial_muestra) }}</span> 
                                                </label>                                    
                                                <input type="number" class="form-control input-3d" v-model=datos.registro.saldo_inicial :disabled=datos.data_table.cargando>                                                

                                                <p v-if="datos.registro.saldo_inicial!==''" style="color:white; text-align:center; margin-top:1em;">
                                                    {{ formato_moneda(datos.registro.saldo_inicial) }}
                                                </p>
                                            </div>
                                            <button type="button" class="boton-3d-success" style="margin-bottom:0.2em;" v-if="datos.registro.saldo_inicial!==''" @click=enviar_datos>
                                                Guardar
                                            </button>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-1"></div>
                                    <div class="form-group col-md-4">
                                        <label for="inputEmail4" style="color:white;">
                                            Saldo actual en caja: <span>{{ formato_moneda(datos.registro.saldo_en_caja) }}</span> 
                                        </label>                                            
                                        <label for="inputEmail4" style="color:white;">
                                            <i class='fa fa-plus' style='background:green; padding:0.3em; border-radius:7px;' aria-hidden='true'></i>
                                            Total en ventas: <span>{{ formato_moneda(datos.registro.total_ventas) }}</span> 
                                        </label>  
                                        <!---<label for="inputEmail4" style="color:white;">
                                            <i class='fa fa-plus' style='background:green; padding:0.3em; border-radius:7px;' aria-hidden='true'></i>
                                            Total en ventas pendientes: <span>{{ formato_moneda(datos.registro.total_ventas_pendientes_pagos) }}</span> 
                                        </label>-->
                                        

                                        <label for="inputEmail4" style="color:white;">
                                            <i class='fa fa-plus' style='background:green; padding:0.3em; border-radius:7px;' aria-hidden='true'></i>
                                            Total en ingresos: <span>{{ formato_moneda(datos.registro.total_ingresos) }}</span> 
                                        </label>   
                                        <label for="inputEmail4" style="color:white;">
                                            <i class='fa fa-minus' style='background:red; padding:0.3em; border-radius:7px;' aria-hidden='true'></i>
                                            Total en gastos: <span>{{ formato_moneda(datos.registro.total_gastos) }}</span> 
                                        </label>
                                        <label for="inputEmail4" style="color:white;">
                                            <i class='fa fa-minus' style='background:red; padding:0.3em; border-radius:7px;' aria-hidden='true'></i>
                                            Total en compras: <span>{{ formato_moneda(datos.registro.total_compras) }}</span> 
                                        </label> 
                                        <!-- <label for="inputEmail4" style="color:white;">
                                            <i class='fa fa-minus' style='background:red; padding:0.3em; border-radius:7px;' aria-hidden='true'></i>
                                            Total en prestamos: <span>{{ formato_moneda(datos.registro.total_prestamos) }}</span> 
                                        </label>  -->                                   
                                    </div>                                    

                                </div>
                                
                            <!-- </div> -->       
                            <div v-if="datos.data_table.cargando" class="d-flex justify-content-center" style="width:100%; margin-top:1em; margin-bottom:1em; color:white;">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>     
                            <div id="contenedor-tabla-registros" style="width: 100%;">
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        


    </div>

</template>

<script>
/* eslint-disable */
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import Swal   from '@/librerias/sweetalert2_9/sweetalert2_9.js'
//import { mapMutations } from 'vuex'

import * as calculos  from '@/librerias/lobato-calculos.js'

export default {
    name: 'com_general',
    props: {
        msg: String
    },
    data() {
    return {
        datos:{
            registro_cargando:false,
            registro:{
                id:'',
                fecha_caja:'',
                saldo_inicial_muestra:'',
                saldo_inicial:'',

                saldo_en_caja:'',

                total_ventas:'',
                total_ventas_pendientes_pagos:'',

                total_gastos:'',
                total_compras:'',
                total_ingresos:'',
                total_prestamos:'',



                estado:''          
            },
            productos:{
                todos:[]
            },
            clientes:{
                todos:[]
            },
            data_table:{
                proxima_actualizacion:0,
                id_intervalo_1:'',
                id_intervalo_60:'',
                id_intervalo_1_2:'',

                cargando:false,
                registros:[]
            }
        }
    }
    },
    mounted(){
        this.inicial();
    },
    methods:{
        ...mapMutations(['funciones','alerta']),  
        //...mapActions(['formato_moneda']),
        inicial()
        {
            if(this.general.otros.autenticado===true)
            {
                //this.obtener_recursos();
                this.establecer_fecha_hoy_caja();
                this.data_table();
                //this.actualizar_data_table();
            }
            else if(this.general.otros.autenticado===false)
            {
                this.$router.push('/login');
            }
        },  
        establecer_fecha_hoy_caja()
        {
            let fechaActual = new Date();
            let año = fechaActual.getFullYear();

            let mes = fechaActual.getMonth() + 1;
            mes=mes<10 ? `0${mes}` : mes;

            let dia = fechaActual.getDate();
            dia=dia<10 ? `0${dia}` : dia;

            //let mes = (fechaActual.getMonth() + 1).toString().padStart(2, '0'); // Los meses comienzan desde 0
            //let dia = fechaActual.getDate().toString().padStart(2, '0');
            let fecha = `${año}-${mes}-${dia}`;
            this.datos.registro.fecha_caja=fecha;
            //console.log('fecha hoy');
            //console.log(fechaFormateada);

        },
        obtener_recursos()
        {
            fetch(`${this.general.otros.dominio_server}/compras/recursos`,{
                method:'GET',
                //body:JSON.stringify( this.datos.registro ),
                headers:{
                    'Accept'        :'application/json',
                    'Content-Type'  :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                },
                credentials: 'include',                   
            })
            .then(res=>res.json())
            .then(respuesta=>{
                
                console.log('recursos');
                console.log(respuesta);
                this.datos.productos.todos  =respuesta.datos.productos;
                this.datos.clientes.todos   =respuesta.datos.clientes;

            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los recursos`});
            })
            .finally( () => {
                //this.datos.data_table.cargando=false;                
            });
            
        },    
        boton_modal_registro()
        {
            for (const p in this.datos.registro) {                    
                
                if(p=='productos')
                {
                    this.datos.registro[p]=[];
                }
                else
                {
                    this.datos.registro[p]='';
                }
                
            }            

            this.funciones({nombre:'sonido',sonido:this.general.sonidos.abrir});
            $("#modal-registro").modal("show");
        },
        cambiar_fecha()
        {
            if(this.datos.registro.fecha_caja!=='')
            {
                this.data_table();
            }
        },
        actualizar_data_table()
        {
            let act_cada=60;//parametro en segundos
            this.datos.data_table.proxima_actualizacion=act_cada;               
            this.datos.data_table.id_intervalo_1=setInterval(()=>{        
                this.datos.data_table.proxima_actualizacion--;  
                if(this.datos.data_table.proxima_actualizacion==1)
                {
                    this.data_table();
                    clearInterval(this.datos.data_table.id_intervalo_1);
                }                    
            },1000);

            this.datos.data_table.id_intervalo_60=setInterval(()=>{ 
                this.datos.data_table.proxima_actualizacion=act_cada;               
                //clearInterval(id_intervalo);                
                console.log('ejecucion de 30 s');
                this.datos.data_table.id_intervalo_1_2=setInterval(()=>{
                    this.datos.data_table.proxima_actualizacion--;  
                    if(this.datos.data_table.proxima_actualizacion==1)
                    {
                        this.data_table();
                        clearInterval(this.datos.data_table.id_intervalo_1_2);
                    }                    
                },1000);

            },60000);//parametro en milisegundos
            
        },
        data_table()
        {                        
            //this.alerta({titulo:'Procesando datos',mensaje:'espere ...'});
            if(!this.datos.data_table.cargando)
            {
                this.datos.data_table.cargando=true; 

                this.datos.registro.saldo_inicial_muestra   ='';
                this.datos.registro.saldo_inicial           ='';
                this.datos.registro.saldo_en_caja           ='';

                this.datos.data_table.registros=[];
                this.data_table_crear();

                fetch(`${this.general.otros.dominio_server}/cajas/fecha/${this.datos.registro.fecha_caja}/datos`,{
                    method:'GET',
                    //body:JSON.stringify( this.datos.registro ),
                    headers:{
                        'Accept'        :'application/json',
                        'Content-Type'  :'application/json',
                        //'Authorization' :`Bearer ${this.general.otros.token}`
                        //'X-CSRF-TOKEN':this.general.otros.csrf
                    },
                    credentials: 'include',                   
                })
                .then(res=>res.json())
                .then(respuesta=>{

                    console.log('datos');
                    console.log(respuesta);
                    
                    let r=respuesta.datos;

                    this.datos.registro.saldo_inicial_muestra=r.caja.length>0 ? r.caja[0].saldo_inicial : 0;

                    let saldo_en_caja=this.datos.registro.saldo_inicial_muestra;                    

                    let t=0;
                    let total_compras=0;
                    (r.compras).forEach((item,index)=>{
                        item.descripcion='';
                        item.total_usar=0;
                        if(item.forma_pago=='efectivo')
                        {
                            item.total_usar=item.total;
                        }
                        else if(item.forma_pago=='transferencia')
                        {
                            item.total_usar=0;
                        }
                        else if(item.forma_pago=='efectivo_transferencia')
                        {
                            item.total_usar=item.forma_pago_efe_tra_cant_efec;
                        }

                        saldo_en_caja=calculos.calcular_resta([
                            saldo_en_caja,
                            //item.total
                            item.total_usar
                        ]);
                        item.tipo='compra';
                        this.datos.data_table.registros.push(item);

                        total_compras=calculos.calcular_suma([
                            total_compras,
                            item.total_usar
                        ]);
                    });
                    this.datos.registro.total_compras=total_compras;

                    let total_ventas=0;                
                    (r.ventas).forEach((item,index)=>{
                        //item.forma_pago='efectivo';
                        //item.total_usar=item.total;
                        item.total_usar=0;

                        if(item.forma_pago=='efectivo')
                        {
                            item.total_usar=item.total;
                        }
                        else if(item.forma_pago=='transferencia')
                        {
                            item.total_usar=0;
                        }
                        else if(item.forma_pago=='efectivo_transferencia')
                        {
                            item.total_usar=item.forma_pago_efe_tra_cant_efec;
                        }

                        saldo_en_caja=calculos.calcular_suma([
                            saldo_en_caja,
                            //item.total
                            item.total_usar
                        ]);
                        item.tipo='venta';
                        this.datos.data_table.registros.push(item);

                        total_ventas=calculos.calcular_suma([
                            total_ventas,
                            item.total_usar
                        ]);
                    });
                    this.datos.registro.total_ventas=total_ventas;

                    let total_ventas_pendientes_pagos=0;
                    (r.ventas_pendientes_pagos).forEach((item,index)=>{ 

                        item.total_usar=item.cantidad;
                        item.tipo='venta pendiente pago';
                        item.forma_pago='efectivo';
                        item.no='';
                        item.descripcion='';

                        this.datos.data_table.registros.push(item);

                        saldo_en_caja=calculos.calcular_suma([
                            saldo_en_caja,
                            //item.total
                            item.total_usar
                        ]);

                        total_ventas_pendientes_pagos=calculos.calcular_suma([
                            total_ventas_pendientes_pagos,
                            item.total_usar
                        ]);

                    });
                    this.datos.registro.total_ventas_pendientes_pagos=total_ventas_pendientes_pagos;

                    let total_prestamos=0;
                    (r.prestamos).forEach((item,index)=>{
                        item.descripcion=item.concepto;
                        item.no='';
                        item.forma_pago='prestamo';
                        saldo_en_caja=calculos.calcular_resta([
                            saldo_en_caja,
                            item.total
                        ]);
                        total_prestamos=calculos.calcular_suma([
                            total_prestamos,
                            item.total
                        ]);
                        item.tipo='prestamo';                        
                        this.datos.data_table.registros.push(item);
                    });
                    this.datos.registro.total_prestamos=total_prestamos;

                    let total_gastos=0;
                    let total_ingresos=0;
                    (r.otros_movimientos).forEach((item,index)=>{
                        item.total_usar=item.total;
                        item.no='';
                        item.forma_pago='efectivo';
                        item.cliente_nombre='';
                        item.cliente_apellido_paterno='';
                        item.cliente_apellido_materno='';

                        if(item.tipo=='gasto')
                        {
                            saldo_en_caja=calculos.calcular_resta([
                                saldo_en_caja,
                                item.total_usar
                            ]);
                            total_gastos=calculos.calcular_suma([
                                total_gastos,
                                item.total_usar
                            ]);
                        }
                        else if(item.tipo=='ingreso')
                        {
                            saldo_en_caja=calculos.calcular_suma([
                                saldo_en_caja,
                                item.total_usar
                            ]);
                            total_ingresos=calculos.calcular_suma([
                                total_ingresos,
                                item.total_usar
                            ]);
                        }
                        this.datos.data_table.registros.push(item);
                    });
                    this.datos.registro.total_gastos=total_gastos;
                    this.datos.registro.total_ingresos=total_ingresos;

                    this.datos.registro.saldo_en_caja=saldo_en_caja;        
                    this.data_table_crear();

                    //this.funciones({nombre:'alerta',estatus:'success',mensaje:`Datos actualizados`});

                })
                .catch(error=>{
                    //this.funciones({nombre:'alerta',estatus:'error',mensaje:`Fatos `});
                })
                .finally( () => {
                    this.datos.data_table.cargando=false;   

                    /* setTimeout(() => {
                        //console.log("Retrasado por 1 segundo.");
                        this.data_table();
                    }, "10000"); */
                            
                });
            }
            /* else
            {
                setTimeout(() => {
                    //console.log("Retrasado por 1 segundo.");
                    this.data_table();
                }, "10000");
            } */
        },
        data_table_crear()
        {
            document.getElementById('contenedor-tabla-registros').innerHTML=`
                <table id="tabla-registros" class="table table-hover w-100 pb-30">
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>Operación</th>
                            <th>Forma pago</th>
                            <th>Total</th>
                            <th>Cliente</th>
                            <th>Descripción</th>
                        </tr>
                    </thead>
                    <tbody >
                    </tbody>
                    <tfoot>
                        <tr>
                            <th>No</th>
                            <th>Operación</th>
                            <th>Forma pago</th>
                            <th>Total</th>
                            <th>Cliente</th>
                            <th>Descripción</th>
                        </tr>
                    </tfoot>
                </table>
            `;
            $('#tabla-registros thead tr').clone(true).appendTo( '#tabla-registros thead' );
            $('#tabla-registros thead tr:eq(1) th').each( function (i) {
                var title = $(this).text();

                if(title=='Operación')
                {
                    $(this).html( `
                        <select class="form-control">
                            <option value="">Todos</option>
                            <option value="venta">venta</option>
                            <option value="ingreso">ingreso</option>
                            <option value="gasto">gasto</option>
                            <option value="compra">compra</option>                            
                            <option value="prestamo">prestamo</option>
                        </select>                        
                    ` );
                }
                else if(title=='Forma pago')
                {
                    $(this).html( `
                        <select class="form-control">
                            <option value="">Todos</option>
                            <option value="efectivo">Efectivo</option>
                            <option value="transferencia">Transferencia</option>
                            <option value="ambos">Ambos</option>
                        </select>                        
                    ` );
                }
                else
                {
                    $(this).html( '<input class="form-control" style="width:100%;font-size:11px;" type="text" placeholder="Buscar '+title+'" />' );
                }
        
                $( 'input', this ).on( 'input', function () {
                    if ( tabla_registros.column(i).search() !== this.value ) {
                        tabla_registros
                            .column(i)
                            .search( this.value )
                            .draw();
                    }
                } );

                $( 'select', this ).on( 'change', function () {
                    if ( tabla_registros.column(i).search() !== this.value ) {
                        tabla_registros
                            .column(i)
                            .search( this.value )
                            .draw();
                    }
                } );

            } );
            
            var tabla_registros=$('#tabla-registros').DataTable({
                orderCellsTop: true,
                fixedHeader: true,
                responsive: true,
                autoWidth: true,
                "order":[0,'desc'],
                language: {
                    search: "Buscar",
                    searchPlaceholder: "Buscar",
                    lengthMenu: "Mostrando _MENU_ registros por página",
                    zeroRecords: "No se encontraron registros",
                    info: "Mostrando pagina _PAGE_ de _PAGES_",
                    infoEmpty: "No hay registros disponibles",
                    infoFiltered: "(filtrando de _MAX_ registros)",
                    paginate: {
                        "first":      "First",
                        "last":       "Last",
                        next:       "Siguiente",
                        previous:   "Anterior"
                    },
                },
                //ajax:`/ordenes_elaboracion_materiales/todos`,
                //ajax:`/clientes/todos`,
                data:this.datos.data_table.registros,                
                columnDefs:[
                    {"targets":0, "data":function(data,type,full,meta)
                        {                            
                            return data.no;                            
                        }
                    }, 
                    {"targets":1, "data":function(data,type,full,meta)
                        {                                                    
                            return data.tipo;                           
                        }
                    }, 
                    {"targets":2, "data":function(data,type,full,meta)
                        {      
                            let f_p='';
                            //data.forma_pago=='efectivo_transferencia' ? 'ambos' : data.forma_pago;                     
                            if(data.forma_pago=='efectivo_transferencia')
                            {
                                f_p='ambos';
                            }
                            else if(data.forma_pago=='prestamo')
                            {
                                f_p='';
                            }
                            else
                            {
                                f_p=data.forma_pago;
                            }
                            return f_p;                           
                        }
                    }, 
                    {"targets":3, "data":(data,type,full,meta)=>
                        {                            
                            let t=''; //this.formato_moneda(data.total_usar);

                            if(data.forma_pago=='efectivo_transferencia')
                            {
                                t=`(efec:${this.formato_moneda(data.forma_pago_efe_tra_cant_efec)}) (tran:${ this.formato_moneda(data.forma_pago_efe_tra_cant_tran) })`;
                            }
                            else if(data.forma_pago=='efectivo')
                            {
                                t=this.formato_moneda(data.total_usar);
                            }
                            else if(data.forma_pago=='transferencia')
                            {
                                t=this.formato_moneda(data.total);
                            }
                            else if(data.forma_pago=='prestamo')
                            {
                                t=this.formato_moneda(data.total);
                            }

                            //let c=data.tipo=='compra' ? "<i class='fa fa-minus' style='background:red; padding:0.3em; border-radius:7px;' aria-hidden='true'></i>" : "<i class='fa fa-plus' style='background:green; padding:0.3em; border-radius:7px;' aria-hidden='true'></i>";
                            let c='';

                            if( ['compra','prestamo','gasto'].includes(data.tipo) )
                            {
                                c="<i class='fa fa-minus' style='background:red; padding:0.3em; border-radius:7px;' aria-hidden='true'></i>";
                            }
                            else if( ['venta','ingreso'].includes(data.tipo) )
                            {
                                c="<i class='fa fa-plus' style='background:green; padding:0.3em; border-radius:7px;' aria-hidden='true'></i>";
                            }


                            if(data.forma_pago=='transferencia')
                            {
                                c=t;
                            }
                            else
                            {
                                c=c+t;
                            }

                            return `
                            <p>
                                ${c}
                            </p>
                            `;
                        }
                    },
                    {"targets":4, "data":function(data,type,full,meta)
                        {     
                            let c={
                                n   :'',
                                p   :'',
                                m   :''
                            };
                            if(data.tipo=='prestamo')
                            {
                                if(data.tipo_prestamista=='cliente')
                                {                                    
                                    c.n   =data.cliente_nombre;
                                    c.p   =data.cliente_apellido_paterno;
                                    c.m   =data.cliente_apellido_materno;                                
                                }
                                else if(data.tipo_prestamista=='empleado')
                                {
                                    c.n   =data.users_nombre;
                                    c.p   =data.users_apellido_paterno;
                                    c.m   =data.users_apellido_materno;  
                                }
                            }
                            else
                            {                                     
                                c.n   =data.cliente_nombre;
                                c.p   =data.cliente_apellido_paterno;
                                c.m   =data.cliente_apellido_materno;    
                            }

                            c.n=c.n===null ? '' : c.n;
                            c.p=c.p===null ? '' : c.p;
                            c.m=c.m===null ? '' : c.m;

                            return `${c.n} ${c.p} ${c.m}`;
                        }
                    },
                    {"targets":5, "data":function(data,type,full,meta)
                        {                                                    
                            return data.descripcion;                           
                        }
                    }                      
                ],
                createdRow: function( row, data, dataIndex ) {

                    let dt={
                        'compra'    :'fila-compra',
                        'venta'     :'fila-venta' 
                    };
                    if(data.tipo in dt)
                    {
                        $(row).addClass( dt[data.tipo] );
                    }

                },
                "drawCallback": this.eventos_data_table
            });
            tabla_registros.on( 'responsive-display',  ( e, datatable, row, showHide, update ) => {               
                this.eventos_data_table();
            } );
            
        },
        eventos_data_table()
        {
            /* Array.from(document.getElementsByClassName("boton-modal-editar-registro")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_editar_registro_evento);
            });

            Array.from(document.getElementsByClassName("boton-modal-remover")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_remover);
            });  */                   
        },
        
        

        ////////////////
        material_seleccionado(index)
        {
            /* let p=this.datos.registro.productos[index];
            let a=(this.datos.productos.todos).find((e)=>e.id==p.productos_id);
            p.precio=a===undefined ? 0 : a.precio;
            this.calcular_producto_total(index); */
        },
        calcular_producto_total(index)
        {
            let p=this.datos.registro.productos[index];
            p.total=calculos.calcular_multiplicacion([
                p.precio,
                p.cantidad
            ]);
            p.total=(p.total).toFixed(2);
            this.calcular_registro_venta_total();
        },
        calcular_registro_venta_total()
        {
            let r=this.datos.registro;
            r.total_venta=0;

            (r.productos).forEach((p,index)=>{

                if(p.estado=='activo')
                {                                    
                    r.total_venta=calculos.calcular_suma([
                        r.total_venta,
                        p.total
                    ]);
                }
            });
            console.log(this.datos.registro);
        },
        enviar_datos()
        {
            this.alerta({titulo:'Procesando datos',mensaje:'espere ...'});  
            
            //let p=this.datos.registro.productos.filter((e)=>e.estado=='activo' || (e.estado=='inactivo' && e.id!='') );
            
            fetch(`${this.general.otros.dominio_server}/cajas/registro`,{
                method:'POST',
                body:JSON.stringify( {
                    id              :this.datos.registro.id,
                    fecha_caja      :this.datos.registro.fecha_caja,
                    saldo_inicial   :this.datos.registro.saldo_inicial
                } ),
                headers:{                    
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            //.then(res=>res.json())
            .then(res => {
                //console.log(res);
                //console.log('Estado de la respuesta:', res.status);
                if (res.status == 200) 
                {
                    return res.json();
                }
                else
                {
                    throw new Error(`Error: ${res.status}`);
                }

                //return res.json();
            })
            .then(respuesta=>{
                let dt={
                    'bien':()=>{                        
                        this.data_table();
                        //$("#modal-registro").modal("hide");
                        this.funciones({nombre:'alerta',estatus:'success',mensaje:`Saldo inicial guardado`});
                    }
                };

                if(respuesta.mensaje in dt )
                {
                    dt[respuesta.mensaje]();
                }                
            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`Saldo inicial no pudo guardarse`});
            })
            .finally( () => {
                //this.datos.data_table.cargando=false;
            });
        },
        formato_moneda(m)
        {
            m=calculos.revisar_numero(m);
            return (m).toLocaleString("es-MX",{
                style: 'currency',
                currency: 'MXN'
            });
        },
        actualizar_caja()
        {
            this.cambiar_fecha();
        }
    },
    unmounted() { 
        clearInterval(this.datos.data_table.id_intervalo_1);
        clearInterval(this.datos.data_table.id_intervalo_60);
        clearInterval(this.datos.data_table.id_intervalo_1_2);
    },
    computed: {
        ...mapState(['general']),
        ...mapGetters(['verificacion_rol']),
        /*formato_moneda(m)
        {
            this.formatear_moneda(m);
        } */
    },
    watch: {
        'general.otros.autenticado': function (v) {
            if(v)
            {
                this.inicial();
            }
        }
    }
}
</script>

<style lang="scss" scoped>        
    .contenedor-producto{
        background:linear-gradient(90deg, #0093ff, #484848);
        border-radius:7px; 
        margin-bottom:1em; 
        padding:1em;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.8);
        padding-bottom:0px; 
        padding-top:0.5em;

        /* &:hover{
            background:linear-gradient(90deg, #01253f, #1d1c1c);
        } */

        label {
            color:white;
        }
    }

    
    
</style>

<style lang="scss">        
    .fila-compra{
        background:red !important;
    }
    .fila-venta{
        background:green !important;
    }
</style>